import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M10.01 10h.01', key: '1a2j31' }],
  ['path', { d: 'M12 14.991h.01', key: 'csw8q1' }],
  ['path', { d: 'M12 22v-3', key: 'kmzjlo' }],
  ['path', { d: 'M12 2v3', key: 'qbqxhf' }],
  ['path', { d: 'M13 22h-2', key: '191ugt' }],
  ['path', { d: 'M13 2h-2', key: 'mj6ths' }],
  ['path', { d: 'm16.5 19.794-1-1.733', key: '165y8t' }],
  ['path', { d: 'm16.5 4.205-1 1.732', key: '1v0drn' }],
  ['path', { d: 'M18.891 13.235a7 7 0 00-8.126-8.126', key: 'ols27d' }],
  ['path', { d: 'm19.794 7.5-1.732 1', key: '1f81wk' }],
  ['path', { d: 'M2 12h3', key: '1wrr53' }],
  ['path', { d: 'M2 13v-2', key: 'v9793i' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'M22 12h-3', key: 'silwxu' }],
  ['path', { d: 'M22 13v-2', key: '1nj1a6' }],
  ['path', { d: 'm4.206 16.5 1.732-1', key: '1b8gjo' }],
  ['path', { d: 'm4.206 7.5 1.732 1', key: 'paipwt' }],
  ['path', { d: 'M7.05 7.05a7 7 0 009.9 9.9', key: '1rpkjt' }],
  ['path', { d: 'm7.5 19.794 1-1.733', key: '199mim' }],
  ['path', { d: 'M9 12h.01', key: '157uk2' }],
];

/**
 * @component @name VirusOff
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMDEgMTBoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNC45OTFoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAyMnYtMyIgLz4KICA8cGF0aCBkPSJNMTIgMnYzIiAvPgogIDxwYXRoIGQ9Ik0xMyAyMmgtMiIgLz4KICA8cGF0aCBkPSJNMTMgMmgtMiIgLz4KICA8cGF0aCBkPSJtMTYuNSAxOS43OTQtMS0xLjczMyIgLz4KICA8cGF0aCBkPSJtMTYuNSA0LjIwNS0xIDEuNzMyIiAvPgogIDxwYXRoIGQ9Ik0xOC44OTEgMTMuMjM1YTcgNyAwIDAwLTguMTI2LTguMTI2IiAvPgogIDxwYXRoIGQ9Im0xOS43OTQgNy41LTEuNzMyIDEiIC8+CiAgPHBhdGggZD0iTTIgMTJoMyIgLz4KICA8cGF0aCBkPSJNMiAxM3YtMiIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Ik0yMiAxMmgtMyIgLz4KICA8cGF0aCBkPSJNMjIgMTN2LTIiIC8+CiAgPHBhdGggZD0ibTQuMjA2IDE2LjUgMS43MzItMSIgLz4KICA8cGF0aCBkPSJtNC4yMDYgNy41IDEuNzMyIDEiIC8+CiAgPHBhdGggZD0iTTcuMDUgNy4wNWE3IDcgMCAwMDkuOSA5LjkiIC8+CiAgPHBhdGggZD0ibTcuNSAxOS43OTQgMS0xLjczMyIgLz4KICA8cGF0aCBkPSJNOSAxMmguMDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/virus-off
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VirusOff = createLucideIcon('virus-off', __iconNode);

export default VirusOff;
